import PlannedBuildingElement from "../../models/domain/planned_building_element";
import { AvvirEvent } from "type_aliases";

export type ReviztoAccessTokenDialogShownEvent = AvvirEvent<typeof REVIZTO_ACCESS_TOKEN_DIALOG_SHOWN, { globalId: string, selectedElements: PlannedBuildingElement[] }>

const reviztoAccessTokenDialogShown = (globalId: string, selectedElements: PlannedBuildingElement[]): ReviztoAccessTokenDialogShownEvent => ({
  type: REVIZTO_ACCESS_TOKEN_DIALOG_SHOWN,
  payload: {
    globalId,
    selectedElements,
  }
});

export const REVIZTO_ACCESS_TOKEN_DIALOG_SHOWN = "revizto_access_token_dialog_shown";

export default reviztoAccessTokenDialogShown;
